import { API_URL, getCachedSessionId } from 'src/services/common';
import { api } from '../../../../util/axios-instance';

export const fetchUsers = async (id) => {
  const response = await api.get(`${API_URL}/v1/project/${id}/user`, {
    headers: { 'x-session-id': getCachedSessionId() }
  });

  return response?.data;
};
